"use strict";

exports.__esModule = true;
exports.DeviceCollection = DeviceCollection;
var _react = _interopRequireDefault(require("react"));
var _API = require("../../API");
var _excluded = ["children", "sortConfig"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Provides access to devices via a render prop.
 */
function DeviceCollection(_ref) {
  var children = _ref.children,
    _ref$sortConfig = _ref.sortConfig,
    sortConfig = _ref$sortConfig === void 0 ? {
      prop: "name",
      sortArrayOfObjectsByKey: true
    } : _ref$sortConfig,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_API.Collection, _extends({
    primaryKey: "uuid",
    baseURL: "/api/v1/plant/device",
    itemBaseURL: "/api/v1/plant/device/:uuid",
    updateMethod: "PUT",
    sortConfig: sortConfig
  }, extra), children);
}